import { ResolutionSchema } from '../lookup/ResolutionSchema.js';
import { SchemaError } from '../errors/SchemaError.js';
export class ResolutionSchemaParser {
    constructor(resolutionSchemaDefinition, registeredTypes) {
        this.resolutionSchemaDefinition = resolutionSchemaDefinition;
        this.registeredTypes = registeredTypes;
    }
    parse() {
        this.result = new Map();
        this.parseProducts();
        return this.result;
    }
    parseProducts() {
        if (Array.isArray(this.resolutionSchemaDefinition.products)) {
            for (let i = 0; i < this.resolutionSchemaDefinition.products.length; i++) {
                let resolutionSchemaDeclaration = this.resolutionSchemaDefinition.products[i];
                this.parseProductResolutionSchemaDefinition(resolutionSchemaDeclaration, i);
            }
        }
        else
            throw SchemaError.invalidResolutionSchemaProductsDefinition();
    }
    parseProductResolutionSchemaDefinition(definition, index) {
        if (!definition.type) {
            throw SchemaError.productResolutionSchemaTypedMissed(index);
        }
        if (!this.registeredTypes.has(definition.type)) {
            throw SchemaError.invalidTypeInProductResolutionSchema(definition.type, index);
        }
        const lookups = definition.resolutionSchema.lookups;
        for (const lookup of lookups) {
            this.validateLookup(lookup);
        }
        const resolutionSchema = new ResolutionSchema(lookups);
        this.result.set(definition.type, resolutionSchema);
    }
    validateLookup(lookup) {
        if (!lookup.variation) {
            lookup.variation = [];
        }
    }
}
//# sourceMappingURL=ResolutionSchemaParser.js.map